<template >
  <v-container class="auth" mt-4>
      <!-- <img src="../assets/tracking2.jpg"/> -->
    <v-form>
      <v-layout align-content-space-around justify-center column fill-height> 
        <v-card>
          <v-flex xs12 mt-4 mb-4>
            <img src="../assets/coi-logo.png"/>
          </v-flex>
<!--          <v-flex mb-5>-->
<!--            <span class="sub-heading" align-end justify-end row>Vehicle Tracking Tool</span>-->
<!--          </v-flex>-->
          <v-flex xs12 pl-4 pr-4>
            <v-text-field v-model="credentials.email" type="text" name="email" label="Email Address"></v-text-field>
          </v-flex>
          <v-flex xs12 pl-4 pr-4>
            <v-text-field v-model="credentials.password" type="password" name="password" label="Password" ></v-text-field>
          </v-flex>
          <v-flex xs12 pl-4 pr-4 mb-4>
            <v-btn class="btn-submit" color="primary" block v-on:click="login()">SIGN IN</v-btn>
          </v-flex>
          <!-- <v-flex xs12 pl-4 pr-4 class="forgot-pass">
            <span class="subheading">Forgot password?</span>
          </v-flex> -->
        </v-card>               
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";

export default {
  name: "Auth",
  components: {},
  data() {
    return {
      credentials: {
        email: null,
        password: null
      }
    };
  },
  methods: {
    async login() {
      try {
        const response = await AuthenticationService.login(this.credentials);
        console.log(response);
        if (response.data.code == 406) {
          this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: "error", x: "right", timeout: 3000});
        } else if (response.data.result == 2000) {
          this.$store.dispatch("setUser", response.data.data);
          this.$session.start();
          console.log("login response: ", response.data.data);
          this.$session.set("user", response.data.data);
          // this.$session.set("user", this.$store.getters.getUser());
          // this.$session.set("user", this.$store.state.auth.user);
          console.log("session user set: ", this.$session.get("user"));
          if (this.$store.state.auth.user.role == 3) {
            this.$router.push({ name: "calendar" });
          } else {
            this.$router.push({ name: "dashboard" });
          }
          this.$store.dispatch("setSnackbar", {show: true, text: "Logged in as '" + this.$store.getters.fullName + "'", color: "info", x: "right", timeout: 3000});
        } else {
          throw "Something went wrong";
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setSnackbar", {show: true, text: "Log in error occured", color: "warning", x: "right", timeout: 3000});
      }
    }
  }
};
</script>

<style scoped>
/* .auth{
  background: url('../../src/assets/tracking2.jpg');
  background-size:cover;
} */

.container {
  max-width: 400px;
  float: left;
}

/* .v-card {
  opacity: 0.85;
}

.v-text-field {
  opacity: 1;
  background: rgba(0, 0, 0, 1);
}

.v-btn {
  opacity: 1;
  background: rgba(0, 0, 0, 1);
} */


img {
  height: 80px;
  padding: 3px;
}

.title {
  margin-bottom: 40px;
}

.forgot-pass {
  margin-top: 20px;
  text-decoration: underline;
  margin-bottom: 40px;
}

.sub-heading {
  text-align: right;
}

.v-text-field input {
  margin-top: 26px !important;
}

</style>
